import { type Moment } from "moment";
import { type RouteComponentProps } from "react-router";

import { type MenuItemName } from "types/enum";

export interface IHeaderAlertExtraData {
    alertDate?: Moment;
    integration?: string;
    linkText?: string;
    url?: string;
}

/**
 * Hand-mirrored from the C# `AlertType` in `Global.Core/Types/SystemAlert.cs`. These are not generated,
 * so a value added there must be added here with the same number - a mismatch renders the wrong banner
 * with no error.
 */
export enum AlertType {
    Subscription = 0,
    Maintenance = 1,
    Accounting = 2,
    GeneralWarning = 3,
    MFAWarning = 4,
    LeadEmailOverage = 5,
    AccountingOutage = 6,
}

export interface IBannerAlertProps<ExtraDataType = IHeaderAlertExtraData>
    extends RouteComponentProps {
    alert: IAlert<ExtraDataType>;
    selectedMenuItem?: MenuItemName;
}

export class IAlert<ExtraDataType> {
    alertTitle: string;
    alertText: string;
    redirectText: string;
    alertType: AlertType;
    extraData?: ExtraDataType;
}
